const COMPONENT_NAME = "countdown-timer";
const CLASS_SELECTOR = ".CountdownTimer";
const NODE_SELECTOR = ".CountdownTimer-value";
const CSS_INITIALIZED = 'is-initialized';

const timers = [];

function initialize(rootElement, PageComponents) {
    if (rootElement.classList.contains(CSS_INITIALIZED)) return;

    const Nodes = rootElement.querySelectorAll(NODE_SELECTOR);
    const timestamp = parseInt(rootElement.dataset.timestamp) * 1000;

    let interval;

    function shutdown() {
        Nodes.forEach((node) => node.innerText = "0");
        clearInterval(interval);
    }

    function sync() {
        const now = Date.now();
        if (now >= timestamp) {
            shutdown();
            return;
        }

        let duration = Math.floor((timestamp - now) / 1000);
        Nodes[0].innerText = Math.floor(duration / 86400);
        duration %= 86400;
        Nodes[1].innerText = Math.floor(duration / 3600);
        duration %= 3600;
        Nodes[2].innerText = Math.floor(duration / 60);
        duration %= 60;
        Nodes[3].innerText = duration;
    }

    sync();

    interval = setInterval(sync, 1000);
    rootElement.classList.add(CSS_INITIALIZED)
    timers.push({
        element: rootElement,
        sync,
        shutdown
    });
}

module.exports = {
    name: COMPONENT_NAME,
    instances: timers,
    initialize
};
